import Service from "../Service";

const resource = "/humanresource/card/";

export default {

    save(list) {
        return Service.post(resource + "save", list, {
            responseType: "blob",
            headers: {
                "Content-Type": "application/json",
            },
        });
    },

    pagination(dtr, requestID) {
        return Service.post(resource + "pagination", dtr, {
            params: { requestID: requestID },
        });
    },

    // Nuevo: impresión física con Evolis usando FormData
    printPhysical(formData) {
        console.log("Printing physical cards with FormData");
        
        return Service.post(resource + "print-physical", formData, {
            headers: { 
                "Content-Type": "multipart/form-data" 
            },
        });
    },

    // Nuevo: guardar recursos del nuevo dise�o (frente/dorso)
    saveResources(payload) {
        return Service.post(resource + "save-fotocheck-resources", payload, {
            headers: { "Content-Type": "application/json" },
        });
    },

};